import { Check } from "lucide-react-native";
import { Box, HStack, Icon, IToastProps, Text, Toast } from "native-base";
import React from "react";
import { copyEvent } from "../../Navigator/TopNavigator/ExpandedMenu/utils";
const copy_toast_config: IToastProps = {
    placement: 'top',
    duration: 1800,
    render: () => (
        <Box
            bg="emerald.600"
            px="4"
            py="3"
            rounded="xl"
            shadow="9"
        >
            <HStack space={3} alignItems="center">
                <Icon
                    as={Check}
                    color="white"
                    size="sm"
                />
                <Text color="white" fontWeight="600">
                    Copied
                </Text>
            </HStack>
        </Box>
    ),
}

export const show_toast = ({ toast_config = copy_toast_config }) => {
    Toast.show(
        toast_config
    )
}

export const copyArt = async ({
    art
}) => {
     await copyEvent({
                        text: art,
                        onSuccess: () => {
                            show_toast({})
                        }
                    }
                    )
}